import React from 'react';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { WebApps } from './TopUsedApps';
import '../../../styles/Dashboard/topUsedApps.scss';


interface Props {
    isLoading: boolean,
    totalTime: string,
    appData: WebApps[],
    title: string,
}

const TopUsedAppsCard = (props: Props) => {
    const { isLoading, totalTime, appData, title } = props;

    return (
        <>
            <div className={`title-cont ${title === 'Most used unproductive apps & sites' ?
                'un-prod' : title === 'Most used neutral apps & sites' ? 'ntl-app' : ''}`}>
                <h5>{title}</h5>
            </div>
            <div className="prs-cnl-cont">
                <div className="prs-cont">
                    {isLoading ?
                        <>
                            <p><Skeleton className='w-25' count={1} /></p>
                            <div className="prs-bar">
                                <Skeleton className='w-100' count={1} />
                            </div>
                            <div className="app-legend-cont">
                                {Array.from({ length: 3 })?.map((res, i) => (
                                    <div className="legend w-25 align-items-center" key={i}>
                                        <div>
                                            <Skeleton count={1} circle={true} className="skel-chart" />
                                        </div>
                                        <p className="w-100">
                                            <Skeleton className='w-100' count={1} />
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </> :
                        <>
                            <p>{totalTime}</p>
                            <ProgressBar className="prs-bar">
                                {appData?.map((res, i) => (
                                    <ProgressBar variant={`top-${i === 0 ? 'one' : i === 1 ? 'two' : i === 2 ? 'three' : i === 3 ? 'four' : 'five'}`}
                                        now={res?.percentage}
                                        key={i}
                                    />
                                ))}
                            </ProgressBar>
                            <div className="app-legend-cont">
                                {appData?.map((res, i) => (
                                    <div className="legend" key={res?.app}>
                                        <div className={`lgd-circle bg-top-${i === 0 ? 'one' : i === 1 ? 'two' : i === 2 ? 'three' : i === 3 ? 'four' : 'five'}`}></div>
                                        <p>{res?.app}</p>
                                    </div>
                                ))}
                            </div>
                        </>
                    }
                </div>
                <hr />
                <div className="cnl-cont">
                    <div>
                        <Row className="cnl-row">
                            <Col md={9} className="cnl-col">
                                <h5>Channels</h5>
                            </Col>
                            <Col md={3} className="cnl-col text-end">
                                <h5>Total hours</h5>
                            </Col>
                        </Row>
                    </div>
                    <div className="cnl-name-hrs">
                        {isLoading ?
                            Array.from({ length: 5 })?.map((res, i) => (
                                <Row className="cnl-row" key={i}>
                                    <Col md={9} className="cnl-col">
                                        <p>
                                            <Skeleton className='w-75' count={1} />
                                        </p>
                                    </Col>
                                    <Col md={3} className="cnl-col text-end">
                                        <p className="cnl-hrs">
                                            <Skeleton className='w-75' count={1} />
                                        </p>
                                    </Col>
                                </Row>
                            ))
                            :
                            appData?.map((res, i) => (
                                <Row className="cnl-row" key={i}>
                                    <Col md={9} className="cnl-col">
                                        <p>{res?.app}</p>
                                    </Col>
                                    <Col md={3} className="cnl-col text-end">
                                        <p className="cnl-hrs">{res?.time}</p>
                                    </Col>
                                </Row>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopUsedAppsCard;